/**
 * Events slider
 */
(function($) {
  "use strict";

  $(window).ready(slickify);

  // Constants
  var eventsSlider = ".view-id-bloc_etablissement .view-content";


  /**
   * Init
   */
  function slickify() {

    $(eventsSlider).not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      customPaging: function (slider, i) {
        var title = $(slider.$slides[i]).find('h3').text();
        return '<button>' + title + '</button>';
      }
    });

  }

})(jQuery);

